import { render, staticRenderFns } from "./ProductDetailsCategories.vue?vue&type=template&id=1e6ebdd0&scoped=true"
import script from "./ProductDetailsCategories.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsCategories.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetailsCategories.vue?vue&type=style&index=0&id=1e6ebdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ebdd0",
  null
  
)

export default component.exports